export enum DEPLOY_VESTING_TYPE_OPTIONS {
  INSTANT = 'instant',
  CONTINUOUS = 'continuous',
  MONTHLY = 'monthly',
}
